import React from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import BbCollapse from '../../common/BbCollapse';
import CustomTooltip from "../../common/customTooltip";
import HistoryLink from '../../common/historyLink';
import MoreLink from '../../common/moreLink';

class HistoryRowComponent extends React.Component {
    state = {
        expanded: false,
        isExpandedTouched: false,
        expandedCompany: false,
        isExpandedCompanyTouched: false,
        expandedUngroupedNames: false,
        isExpandedUngroupedNamesTouched: false
    }
    hasHistory = this.props.historyNames && this.props.historyNames.length > 0;

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false, isExpandedCompanyTouched: false, isExpandedUngroupedNamesTouched: false });
        }
    }

    render() {
        return (this.props.name || this.hasHistory) ? (
            <div className={`ident-item ${this.hasHistory ? "has-history" : ""}`}>
                <span>
                    <span><Translate id="Report.CompanyIdentification.CompanyName" /></span>
                </span>
                <span>
                    {this.renderPrimaryNameRow(this.props.name, this.props.source, this.props.SourceFullCompany, false, this.props.from, (this.props.primaryNames != null && this.props.primaryNames.length > 0))}
                    {this.props.primaryNames &&
                        <BbCollapse className="id-collapse" isOpen={this.props.resolveExpanded(this.state.expandedCompany, this.state.isExpandedCompanyTouched)}>
                            <React.Fragment>
                                {this.props.primaryNames.map((hn, i) =>
                                    this.renderRow(hn.name, hn.source, hn.SourceFull, false, hn.fromFormated, hn.toFormated, i)
                                )}
                            </React.Fragment>
                        </BbCollapse>
                    }
                    {this.hasHistory &&
                        <span>
                            <span className="link-functional print-hidden"
                                onClick={() => this.setState({
                                    expanded: !this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched),
                                    isExpandedTouched: true
                                })}>

                                <HistoryLink noWrapper historyExpanded={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)} />
                            </span>
                        </span>
                    }
                    {this.props.historyNames &&
                        <BbCollapse className="id-collapse" isOpen={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)}>
                            <React.Fragment>
                                {this.props.historyNames.map((hn, i) =>
                                    this.renderRow(hn.name, hn.source, hn.SourceFull, true, hn.fromFormated, hn.toFormated, i, false, (this.props.primaryNamesUngrouped != null && this.props.primaryNamesUngrouped.length > 0))
                                )}
                            </React.Fragment>
                        </BbCollapse>
                    }
                    {this.props.primaryNamesUngrouped &&
                        <BbCollapse className="id-collapse" isOpen={this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched)}>
                            <React.Fragment>
                                <span className="history-row"><span className="id-name bold-name" style={{ fontWeight: 'bold' }}><Translate id="MarketingList.Common.UngroupedNamesSection" /></span></span>
                                {this.props.primaryNamesUngrouped.map((hn, i) =>
                                    this.renderRow(hn.name, hn.source, hn.SourceFull, true, hn.fromFormated, hn.toFormated, i, true)
                                )}
                            </React.Fragment>
                        </BbCollapse>
                    }
                </span>
            </div>
        ) : null;
    }

    renderPrimaryNameRow = (name, source, sourceFull, isHistory, from, renderMoreButton) =>
        <div className="history-row" key="primaryName">
            {!isHistory &&
                <div className="id-name">
                    <div style={{ width: '70%' }}>
                        <span className="bold-name">{name}</span>
                        
                        {from != null && <span className="small" style={{ display: 'inline-block' }}>&nbsp;{`(`}<Translate id="Report.Common.From" />&nbsp;{from})
                            {renderMoreButton &&
                            <>
                                &nbsp;
                                <span className="link-functional print-hidden"
                                    style={{ display: 'inline-block' }}
                                    onClick={() => this.setState({
                                        expandedCompany: !this.props.resolveExpanded(this.state.expandedCompany, this.state.isExpandedCompanyTouched),
                                        isExpandedCompanyTouched: true
                                    })}>
                                    <MoreLink noWrapper moreExpanded={this.props.resolveExpanded(this.state.expandedCompany, this.state.isExpandedCompanyTouched)} />
                                    </span>
                            </>}
                        </span>}
                    </div>
                    <div style={{ width: '30%' }}>
                        {source && <span className="src" id="commonSource" style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                            (<Translate id="Report.Common.Source" />:&nbsp;{source})
                            <CustomTooltip textAlign="right" placement='left' id="commonSource" text={sourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                            </CustomTooltip>
                        </span>}
                    </div>
                </div>
            }
        </div>

    renderRow = (name, source, sourceFull, isHistory, from, to, i, isUngrouped = false, renderMoreButton = false) =>
        <div className={`${isHistory ? "history-row" : "normal-row"}`} key={i}>
            {!isHistory &&
                <div className="id-name">
                    <div style={{ width: '70%' }}>
                        <span>{name}&nbsp;</span>
                        {from != null && <span className="small" style={{ display: 'inline-block' }}>&nbsp;{`(`}<Translate id="Report.Common.From" />&nbsp;{from}&nbsp;)</span>}
                    </div>
                    <div style={{ width: '30%' }}>
                        {source && <span className="src" id={"primaryNames" + i} style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                            (<Translate id="Report.Common.Source" />:&nbsp;{source})
                            <CustomTooltip textAlign="right" placement='left' id={"primaryNames" + i} text={sourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                            </CustomTooltip>
                        </span>}
                    </div>
                </div>
            }

            {isHistory &&
                <div className="id-name">
                    <div style={{ width: '70%' }}>
                        <span>{name}&nbsp;</span>
                        <span className="small" style={{ display: 'inline-block' }}>&nbsp;{`(`}<Translate id="Report.Common.From" />&nbsp;{from}&nbsp;
                            <Translate id="Report.Common.To" />&nbsp;{to}&nbsp;)</span>
                        &nbsp;
                        {(this.props.historyNames.length - 1 == i && isUngrouped == false && renderMoreButton) &&
                            <>
                                &nbsp;
                                <span className="link-functional print-hidden"
                                    style={{ display: 'inline-block' }}
                                    onClick={() => this.setState({
                                        expandedUngroupedNames: !this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched),
                                        isExpandedUngroupedNamesTouched: true
                                    })} >;
                                    <MoreLink noWrapper moreExpanded={this.props.resolveExpanded(this.state.expandedUngroupedNames, this.state.isExpandedUngroupedNamesTouched)} />
                            </span>
                        </>}
                    </div>
                    <div style={{ width: '30%' }}>
                        {source && <span className="src" id={isUngrouped == false ? "historyName" + i : "nameUngrouped" + i} style={{ alignSelf: "flex-end", marginLeft: 'auto', float: 'right' }}>
                            (<Translate id="Report.Common.Source" />:&nbsp;{source})
                            <CustomTooltip textAlign="right" placement='left' id={isUngrouped == false ? "historyName" + i : "nameUngrouped" + i} innerClassName='tooltipSection'
                                text={sourceFull} hideIcon delay={{ "show": 0, "hide": 0 }}>
                            </CustomTooltip>
                        </span>}
                    </div>
                </div>
            }
        </div>
};

const HistoryRow = connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(HistoryRowComponent);

export default HistoryRow;